<template>
  <lm-dropdown
    class="d-inline-block datatable-dropdowns"
    :value="optionsSelected"
    :dataItems="options"
    @input="onClick"
  >
    <button class="toggle text-nowrap">
      {{ label }}
      <span class="toggle-count" v-if="optionsSelectedCount">
        {{ optionsSelectedCount }}
      </span>
    </button>
  </lm-dropdown>
</template>

<script>
// Components
import LmDropdown from '@/components/LmDropdown'
import DropdownMenu from '@innologica/vue-dropdown-menu'

// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    label: String,
    optionsPath: String,
    pick: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    extraArgs: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    LmDropdown,
    DropdownMenu
  },
  data () {
    return {
      show: false,
      search: '',
      options: []
    }
  },
  watch: {
    extraArgs: {
      deep: true,
      async handler (args) {
        this.reloadOptions(args)
      }
    }
  },
  computed: {
    optionsSelectedCount () {
      return this.options.filter(el => el.selected).length
    },
    optionsSelected () {
      return this.options.filter(el => el.selected)
        .map(el => {
          return {
            id: el.id,
            name: el.name,
            value: el.value
          }
        })
    },
    optionsFiltered () {
      return this.options.filter(el => {
        return el.name.toLowerCase().search(this.search.toLowerCase()) >= 0
      })
    }
  },
  methods: {
    async loadOptions (filtersToApply = false) {
      try {
        const res = await commonsApi.axiosPostWrapper(this.optionsPath, {
          slug: this.extraArgs.slug,
          search: this.extraArgs.search,
          filters: filtersToApply || this.extraArgs.filtersToApply,
          queryString: this.extraArgs.queryString,
          calendarQuery: this.extraArgs.calendarQuery
        })

        this.options = res.data.items.map(el => {
          return {
            ...el,
            selected: false
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async reloadOptions (args) {
      try {
        const res = await commonsApi.axiosPostWrapper(this.optionsPath, {
          slug: this.extraArgs.slug,
          search: args.search,
          filters: args.filtersToApply,
          queryString: args.queryString,
          calendarQuery: this.extraArgs.calendarQuery
        })
        this.options = []

        this.options = res.data.items.map(el => {
          return {
            ...el,
            selected: false
          }
        })
        this.loadPickedOptions()
      } catch (error) {
        console.log(error)
      }
    },
    loadPickedOptions () {
      if (this.pick.length) {
        const picks = this.pick.map(el => el.id)
        this.options.forEach(el => {
          if (picks.includes(el.id)) {
            el.selected = true
          }
        })
      }
    },
    async onClick (item) {
      if (!this.multiple) {
        this.options = this.options.map(el => {
          if (el.id !== item.id) el.selected = false
          return el
        })
      }
      item.selected = !item.selected
      this.$emit('change', this.optionsSelected)
    }
  },
  async created () {
    await this.loadOptions()
    await this.loadPickedOptions()
  }
}
</script>

<style>
.datatable-dropdowns .dropdown-menu {
  margin-top: 5px;
  padding: 0;
}

.datatable-dropdowns button.toggle {
  display: flex;
  gap: 10px;
  background-color: #e9ecef;
  border: 0;
  padding: .5rem .8rem;
  border-radius: 8px;
}

.datatable-dropdowns button.toggle .toggle-count {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 21px;
  height: 21px;
  border-radius: 50%;
}
</style>
